export const QUERY_KEYS = {
  USER_DETAILS: 'USER_DETAILS',
  LOG_OUT: 'LOGOUT',
  ALL_FOODS: 'ALL_FOODS',
  ALL_SUPPLEMENTS: 'ALL_SUPPLEMENTS',
  FOOD_DETAILS: 'FOOD_DETAILS',
  SUPPLEMENT_DETAILS: 'SUPPLEMENT_DETAILS',
  FOOD_META_DETAILS: 'FOOD_META_DETAILS',
  FOOD_FILTER: 'FOOD_FILTER',
  FOOD_RANK: 'FOOD_RANK',
  NUTRITION_TIPS: 'NUTRITION_TIPS',
  DAILY_SERVING_DATA: 'DAILY_SERVING_DATA',
  SUPPLEMENT_FILTER: 'SUPPLEMENT_FILTER',
  NUTRITION_HEADER_CONTENT: 'NUTRITION_HEADER_CONTENT',
  NUTRITION_EDUCATIONAL_CONTENT: 'NUTRITION_EDUCATIONAL_CONTENT',
  FOOD_PRODUCTS: 'FOOD_PRODUCTS',
  INIT_DATA: 'INIT_DATA',
  HEALTH_ZONES_SUMMARY: 'HEALTH_ZONES_SUMMARY',
  MY_LONGEVITY: 'MY_LONGEVITY',
  MY_MICROBIOME_PROFILES: 'MY_MICROBIOME_PROFILES',
  MY_ACTIVE_MICROBES: 'MY_ACTIVE_MICROBES',
  MICROBIOME_DETAIL: 'MICROBIOME_DETAIL',
  HEALTH_CONNECTIONS_SUMMARY: 'HEALTH_CONNECTIONS_SUMMARY',
  BIO_AGE_DETAIL: 'BIO_AGE_DETAIL',
  HEALTH_CONNECTIONS_LIST: 'HEALTH_CONNECTIONS_LIST',
  DOCTORS_NOTE: 'DOCTORS_NOTE',
  COMMONLY_LINKED_SYMPTOMS: 'COMMONLY_LINKED_SYMPTOMS',
  L4_CONNECTION_LIST: 'L4_CONNECTION_LIST',
  SCORE_REFERENCE: 'SCORE_REFERENCE',
  INFLAMMAGING_DETAIL: 'INFLAMMAGING_DETAIL',
  HEALTH_CONNECTIONS_DETAIL: 'HEALTH_CONNECTIONS_DETAIL',
  HEALTH_CONNECTIONS_L4_DETAIL: 'HEALTH_CONNECTIONS_L4_DETAIL',
  HEALTH_BOOSTER_AND_BLOCKER: 'HEALTH_BOOSTER_AND_BLOCKER',
  HEALTH_ZONE_DETAIL: 'HEALTH_ZONE_DETAIL',
  HEALTH_CONTRIBUTING_SCORES: 'HEALTH_CONTRIBUTING_SCORES',
  HEALTH_SCORE_DETAILS: 'HEALTH_SCORE_DETAILS',
  ALL_NOTIFICATIONS: 'ALL_NOTIFICATIONS',
  ALL_NOTIFICATIONS_COUNT: 'ALL_NOTIFICATIONS_COUNT',
  HEALTH_SUMMARY: 'HEALTH_SUMMARY',
  NUTRITION_SUMMARY_LIST: 'HEALTH_SUMMARY_LIST',
  NUTRITION_SUMMARY_DETAIL: 'NUTRITION_SUMMARY_DETAIL',
  NUTRITION_SUMMARY_DETAIL_BLOOD_SUGAR: 'NUTRITION_SUMMARY_DETAIL_BLOOD_SUGAR',
  FEATURED_FOOD: 'FEATURED_FOOD',
  NUTRITION_SUMMARY: 'NUTRITION_SUMMARY',
  KIT_STATUS: 'KIT_STATUS',
  INTRO_QUESTIONNAIRES: 'INTRO_QUESTIONNAIRES',
  PLANT_VIRUS: 'PLANT_VIRUS',
  JOURNEY_STATES: 'JOURNEY_STATES',
  EDUCATION_VIDEOS: 'EDUCATION_VIDEOS',
  SAMPLE_DETAIL: 'SAMPLE_DETAIL',
  PEEK_INTO_DATA: 'PEEK_INTO_DATA',
  SUBSCRIPTION_STATUS: 'SUBSCRIPTION_STATUS',
  IMPROVE_SCORE_SUMMARY: 'IMPROVE_SCORE_SUMMARY',
  IMPROVE_SCORE_DETAIL: 'IMPROVE_SCORE_DETAIL',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  FEATURE_KEYS: 'FEATURE_KEYS',

  //contentFul Keys
  PRODUCT_TEST_KIT: 'PRODUCT_TEST_KIT',
  PRODUCT_FORMULAS: 'PRODUCT_FORMULAS',

  SHOP_PAGE_TESTS: 'SHOP_PAGE_TESTS',
  SHOP_PAGE_FORMULAS: 'SHOP_PAGE_FORMULAS',

  MERGED_SHOP_TESTS: 'MERGED_SHOP_TESTS',
  MERGED_SHOP_FORMULAS: 'MERGED_SHOP_FORMULAS',
  SHOP_PAGE_PLANS: 'SHOP_PAGE_PLANS',

  SHOPIFY_MULTIPASS: 'SHOPIFY_MULTIPASS',
  FORMULA_BENEFITS: 'FORMULA_BENEFITS',
};

export const JourneyEducationTypes = {
  NUTRITION_FOOTER: 'nutrition_footer',
  HEALTH_HOME: 'health_home',
  L2_DETAIL: 'l2_detail',
  L2_DETAIL_IMMUNE: 'l2_detail_immune',
  L2_DETAIL_MOOD: 'l2_detail_mood',
  L2_DETAIL_ORAL: 'l2_detail_oral',
  L2_DETAIL_ENERGY: 'l2_detail_energy',
  L2_DETAIL_HEART: 'l2_detail_heart',
  L2_DETAIL_GUT: 'l2_detail_gut',
  BIOAGE_DETAIL: 'bioage_detail',
  INFLAMMAGING_DETAIL: 'inflammaging_detail',
  GUT_MICROBIOME_DETAIL: 'gut_microbiome_detail',
  ORAL_MICROBIOME_DETAIL: 'oral_microbiome_detail',
  HOME_PRE_RNR_TESTING_RESOURCE: 'home_pre_rnr_testing_resource',
  HOME_PRE_RNR: 'home_pre_rnr',
  HOME_POST_RNR: 'home_post_rnr',
  HOME_POST_RNR_RETEST_TESTING_RESOURCE:
    'home_post_rnr_retest_testing_resource',
  HOME_POST_RNR_RETEST: 'home_post_rnr_retest',
  GUT_MICROBIOME: 'gut_microbiome',
  ORAL_MICROBIOME: 'oral_microbiome',
};
